import React, { useEffect, useState } from "react";

import TransportadoraMonogram from "../Transportadoras/TransportadoraMonogram";
import { logoDoConector } from "./logos";

// Logo do conector num fundo branco fixo: logo de terceiro vem em cor chapada e
// some no tema escuro do Hub (mesma decisão do TransportadoraMonogram, PO1-2722).
// Sem logo, ou se a imagem falhar, cai no monograma com a sigla.
//   variant="plaqueta" (padrão): caixa 2:1 com `height`, usada no cabeçalho do painel.
//   variant="faixa": ocupa a largura inteira do topo do card do catálogo.
export default function ConectorLogo({ conector, height = 44, variant = "plaqueta" }) {
  const [falhou, setFalhou] = useState(false);
  const chave = conector ? conector.key : null;
  useEffect(() => {
    setFalhou(false);
  }, [chave]);

  const src = chave && !falhou ? logoDoConector(chave) : null;
  const faixa = variant === "faixa";

  if (!src) {
    const monograma = <TransportadoraMonogram nome={conector && conector.sigla} size={faixa ? 52 : height} />;
    if (!faixa) return monograma;
    return (
      <div
        style={{
          height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderBottom: "1px solid var(--everlog-card-border-faint)",
        }}
      >
        {monograma}
      </div>
    );
  }

  return (
    <div
      style={{
        width: faixa ? "100%" : Math.round(height * 2),
        height,
        borderRadius: faixa ? 0 : Math.max(6, Math.round(height * 0.2)),
        background: "#ffffff", // theme-ok: fundo branco fixo atrás de logo de terceiro (PO1-2722, decisão 7)
        border: faixa ? "none" : "1px solid var(--everlog-card-border-faint)",
        borderBottom: "1px solid var(--everlog-card-border-faint)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        overflow: "hidden",
        padding: faixa ? "14px 24px" : "4px 8px",
        boxSizing: "border-box",
      }}
    >
      <img
        src={src}
        alt={`Logo ${conector.nome}`}
        onError={() => setFalhou(true)}
        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", display: "block" }}
      />
    </div>
  );
}
